import { render, staticRenderFns } from "./ServiceEmployeeCostStatistics.vue?vue&type=template&id=84c0ae66"
import script from "./ServiceEmployeeCostStatistics.vue?vue&type=script&lang=ts"
export * from "./ServiceEmployeeCostStatistics.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports